import React from "react"
import { CapioCommonPage } from "../../pages/CapioCommonPage"
import { CapioNexusUnitListingPage } from "../../pages/CapioNexusUnitListingPage"
import { CapioNexusDiagnosisListingPage } from "../../pages/CapioNexusDiagnosisListingPage"
import { CapioNexusDiagnosisPage } from "../../pages/CapioNexusDiagnosisPage"
import { StartPage } from "../../pages/StartPage"
import { CapioNexusBmiPage } from "../../pages/BmiPage"
import { CapioNexusStandardPage } from "../../pages/CapioNexusStandardPage"
import { CapioStandardNewsPage } from "../../pages/CapioStandardNewsPage"
import { ContentHubArticlePage } from "../../pages/ContentHubArticlePage"
import { CapioLoginPage, ResetPasswordPage } from "../../pages/CapioLoginPage"
import { VarbiCareerPage } from "../../pages/VarbiCareerPage/VarbiCareerPage"
import { MyPagesUserRegistrationPage } from "../../pages/MyPagesUserRegistrationPage"
import { MyPagesManageAccountPage } from "../../pages/MyPagesManageAccountPage"
import { CapioNewsCategoryPage } from "../../pages/CapioNewsCategoryPage"
import { PressAssetsDownloadPage } from "../../pages/PressAssetsDownloadPage"
import { SiteSearchPage } from "../../pages/SiteSearchPage"
import { NewsFeedPage } from "../../pages/NewsFeedPage"
import { MyPagesAccountRemovedPage } from "../../pages/MyPagesAccountRemovedPage"
import { NotFound404 } from "../../pages/ErrorPages"
import { CapioMyPagesLandingPage } from "../../pages/CapioMyPagesLandingPage/CapioMyPagesLandingPage"
import { CapioCookieDeclarationBlock } from "../CapioCookieDeclarationBlock"
import { CapioNexusUnitListBlock } from "../CapioNexusUnitListBlock"

import {
	CapioNexusHeroBlock,
	MainCampaignBlock,
	CapioNexusOurOfferSectionBlock,
	CapioNexusContactSectionBlock,
	CapioNexusEnlistBlock,
	CapioNexusDiscoverSectionBlock,
	CapioNexusStaffBlock,
	CapioNexusFaqSectionBlock,
	CapioNexusCardContainerBlock,
	CapioNexusSearchCareInAppBlock,
	CapioAboutUsBlock,
	CapioCareerListBlock,
	CapioNexusBmiBlock,
	CapioNexusUnitFilterBlock,
	CapioNexusVisitedDiagnosesBlock,
	CommonHeroBlock,
	CapioNexusFormContainerBlock,
	CapioNexusCampaignContainerBlock,
	ContentHubSelectedArticlesBlock,
	CapioCtaBlock,
	ContentHubArticlePageBlock,
	ContentHubArticleListingBlock,
	CapioImageVideoBlock,
	CapioCategoryListingBlock,
	CapioBodyBlock,
	CapioNexusSectionBlock,
	CapioNexusTagLinksBlock,
	CapioCareerFilterBlock,
	CapioEnlistLinkBlock,
	MyPagesHeroBlock,
	MyPagesPersonalizedArticlesBlock,
	MyPagesSavedArticlesBlock,
	MyPagesManageAccountInformationBlock,
	MyPagesRemoveAccountBlock,
	CapioInformationContainerBlock,
	CapioSocialMediaBlock,
	CapioPressContactContainerBlock,
	CapioNexusNewsArchiveBlock,
	CapioNewsListingBlock,
	CapioNexusMediaArchiveBlock,
	PressAssetListingBlock,
	CapioNexusCoworkersBlock,
	CapioQuoteBlock,
	CapioImageTextBlock,
	ImageStackBlock,
	CapioJobylonBlock,
	SearchHeroBlock,
	CapioLatestNewsBlock,
	RelatedUnitsBlock,
	GhpReferralBlock,
	AlertBlock,
	NewsFeedPageBlock,
	MyPagesUserLifestyleFormBlock,
	ConsentsBlock,
	PatientInfoContainerBlock,
	MyPagesSubscribeBlock,
	ProsAndConsBlock

} from ".."

const contentTypeMappings = {
	//Page types
	CapioNexusUnitPage: CapioCommonPage,
	ContentHubCategoryPage: CapioCommonPage,
	CapioMyPagesLandingPage: CapioMyPagesLandingPage,
	ContentHubArticlePage: ContentHubArticlePage,
	CapioLoginPage: CapioLoginPage,
	CapioNexusDiagnosisPage: CapioNexusDiagnosisPage,
	CapioNexusStandardPageModel: CapioNexusStandardPage,
	CapioStandardNewsPage: CapioStandardNewsPage,
	CapioNexusUnitListingPage: CapioNexusUnitListingPage,
	CapioNexusBmiPage: CapioNexusBmiPage,
	CapioNexusDiagnosisListingPage: CapioNexusDiagnosisListingPage,
	MyPagesUserRegistrationPage: MyPagesUserRegistrationPage,
	MyPagesManageAccountPage: MyPagesManageAccountPage,
	CapioMyPagesAccountRemovedPage: MyPagesAccountRemovedPage,
	ResetPasswordPage: ResetPasswordPage,
	StartPage: StartPage,
	VarbiCareerPage: VarbiCareerPage,
	VarbiSpontaneousApplicationCareerPage: VarbiCareerPage,
	CapioNewsLandingPage: CapioCommonPage,
	CapioNewsCategoryPage: CapioNewsCategoryPage,
	PressAssetsDownloadPage: PressAssetsDownloadPage,
	SiteSearchPage: SiteSearchPage,
	NotFoundPage: NotFound404,
	NewsFeedPage: NewsFeedPage,
	// Block types
	CapioAboutUsBlock: CapioAboutUsBlock,
	CapioCareerListBlock: CapioCareerListBlock,
	CapioCareerFilterBlock: CapioCareerFilterBlock,
	CapioCtaBlock: CapioCtaBlock,
	CapioNexusHeroBlock: CapioNexusHeroBlock,
	MyPagesHeroBlock: MyPagesHeroBlock,
	CapioNexusCardContainerBlock: CapioNexusCardContainerBlock,
	CapioNexusOurOfferSectionBlock: CapioNexusOurOfferSectionBlock,
	CapioNexusContactSectionBlock: CapioNexusContactSectionBlock,
	CapioNexusEnlistBlock: CapioNexusEnlistBlock,
	CapioNexusDiscoverSectionBlock: CapioNexusDiscoverSectionBlock,
	CapioNexusStaffBlock: CapioNexusStaffBlock,
	CapioNexusFaqSectionBlock: CapioNexusFaqSectionBlock,
	CapioNexusSearchCareInAppBlock: CapioNexusSearchCareInAppBlock,
	CapioNexusBmiBlock: CapioNexusBmiBlock,
	CapioNexusUnitFilterBlock: CapioNexusUnitFilterBlock,
	CapioNexusUnitListBlock: CapioNexusUnitListBlock,
	CapioNexusVisitedDiagnosesBlock: CapioNexusVisitedDiagnosesBlock,
	CapioNexusFormContainerBlock: CapioNexusFormContainerBlock,
	CapioNexusCampaignContainerBlock: CapioNexusCampaignContainerBlock,
	CapioStartPageHeroBlock: CommonHeroBlock,
	CapioNexusTagLinksBlock: CapioNexusTagLinksBlock,
	CapioVideoBlock: CapioImageVideoBlock,
	CapioStandardNewsPageBlock: ContentHubArticlePageBlock,
	ContentHubArticlePageBlock: ContentHubArticlePageBlock,
	ContentHubArticleListingBlock: ContentHubArticleListingBlock,
	ContentHubSelectedArticlesBlock: ContentHubSelectedArticlesBlock,
	MainCampaignBlock: MainCampaignBlock,
	MyPagesPersonalizedArticlesBlock: MyPagesPersonalizedArticlesBlock,
	MyPagesSavedArticlesBlockModel: MyPagesSavedArticlesBlock,
	MyPagesManageAccountInformationBlock: MyPagesManageAccountInformationBlock,
	MyPagesRemoveAccountBlock: MyPagesRemoveAccountBlock,
	ContentHubCategoryListingBlock: CapioCategoryListingBlock,
	CapioNexusBodyBlock: CapioBodyBlock,
	CapioNexusSectionBlock: CapioNexusSectionBlock,
	CapioCookieDeclarationBlock: CapioCookieDeclarationBlock,
	CapioEnlistLinkBlock: CapioEnlistLinkBlock,
	CapioInformationContainerBlock: CapioInformationContainerBlock,
	CapioSocialMediaBlock: CapioSocialMediaBlock,
	CapioPressContactContainerBlock: CapioPressContactContainerBlock,
	CapioNexusNewsArchiveBlock: CapioNexusNewsArchiveBlock,
	CapioNewsListingBlock: CapioNewsListingBlock,
	CapioNexusMediaArchiveBlock: CapioNexusMediaArchiveBlock,
	PressAssetListingBlock: PressAssetListingBlock,
	CapioNexusCoworkersBlock: CapioNexusCoworkersBlock,
	CapioQuoteBlock: CapioQuoteBlock,
	SearchHeroBlock: SearchHeroBlock,
	CapioImageTextBlock: CapioImageTextBlock,
	ImageStackBlock: ImageStackBlock,
	CapioJobylonBlock: CapioJobylonBlock,
	CapioLatestNewsBlock: CapioLatestNewsBlock,
	RelatedUnitsBlock: RelatedUnitsBlock,
	GhpReferralBlock: GhpReferralBlock,
	AlertBlock: AlertBlock,
	NewsFeedPageBlock: NewsFeedPageBlock,
	MyPagesUserLifestyleFormBlock: MyPagesUserLifestyleFormBlock,
	ConsentsBlock: ConsentsBlock,
	PatientInfoContainerBlock: PatientInfoContainerBlock,
	MyPagesSubscribeBlock: MyPagesSubscribeBlock,
	ProsAndConsBlock: ProsAndConsBlock
}

const getContentByType = (contentType: string): React.FC<any> =>
	contentTypeMappings[contentType] || React.Fragment

export { getContentByType }
